import Waitlist from './Waitlist';

export default Waitlist;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Waitlist/index.js